// ** PTZ DETECTION
const initialState = {
  metallDetection: false,
  metallDetectionHistory: false
}

const metallDetection = (state = initialState, action) => {
  switch (action.type) {
    case "METALL_DETECTION":
      return { ...state, metallDetection: action.val }
    case "METALL_DETECTION_HISTORY":
      return { ...state, metallDetectionHistory: action.val }
    default:
      return state
  }
}

export default metallDetection
